export const billingConstant = {
    GET_BILLING_REPORT_REQUEST: 'GET_BILLING_REPORT_REQUEST',
    GET_BILLING_REPORT_SUCCESS: 'GET_BILLING_REPORT_SUCCESS',
    GET_BILLING_REPORT_FAILURE: 'GET_BILLING_REPORT_FAILURE'
 };